import { render, staticRenderFns } from "./stuDetail.vue?vue&type=template&id=0ddf5331&scoped=true&"
import script from "./stuDetail.vue?vue&type=script&lang=js&"
export * from "./stuDetail.vue?vue&type=script&lang=js&"
import style0 from "./stuDetail.vue?vue&type=style&index=0&id=0ddf5331&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddf5331",
  null
  
)

export default component.exports